<template>
  <div v-if="item.dynamo_offers.length" class="white-bg mb3">
    <div class="flex flex-wrap relative p2 product-title" :class="{'selected': isSelectedProduct}">
      <div class="col-12 flex pointer" @click="toggleDetails">
        <div class="col-11">
          <h3 class="my0">{{ item.name }}</h3>
          <div v-if="priceWithDecimals(item.dynamo_offers[0].detail.lowest_price) > 0" class="inline-block">
            <span>à partir de</span>
            <span class="cond price bold ml1">{{ priceWithDecimals(item.dynamo_offers[0].detail.lowest_price / 100) }} €</span>
            <span v-if="item.dynamo_offers[0].detail.recurring"> / mois </span>
          </div>
        </div>
        <div class="col-1 flex justify-center items-center">
          <i :class="['icon', { 'icon-chevron-down': !isDetailsOpen, 'icon-chevron-up': isDetailsOpen }]"></i>
        </div>
      </div>
    </div>
    <div :id="`details-${componentUid}`" :class="['pointer h4n border-top border-bottom col-12 flex flex-wrap items-center details', { 'open': isDetailsOpen }]">
      <div :id="`details-content-${componentUid}`" class="col-12 px2">
        <div v-for="(offer, index) in item.dynamo_offers" :key="index" class="pointer white-bg col-12 py1 px2 my2 card-top border" @click="handleClick(index)">
          <div class="col-12 flex justify-between">
            <div class="col-10 flex flex-wrap justify-between">
              <div class="col-12 md-col-9">
                <div class="col-12 inline-block">
                  <h2 class="h4 mt1 mb0">{{ offer.name }}</h2>
                </div>
              </div>
              <div class="col-12 md-col-3 inline-block">
                <h5 v-if="priceWithDecimals(offer.detail.lowest_price) > 0" class="h5 mt1 mb0 bold md-right-align">
                  {{ priceWithDecimals(offer.detail.lowest_price / 100) }} € <span v-if="offer.detail.recurring" class="h6">/ mois</span>
                </h5>
              </div>
            </div>
            <div class="col-2 flex justify-center items-center">
              <span :class="['custom-radio flex ', { 'selected-item': isSelectedTariff(`${componentUid}_${index}`) }]"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useId } from 'vue';
import { format } from 'date-fns';

import { priceWithDecimals, computeTotalPrice } from '@/utils/labels';

export default {
  props: {
    item: Object,
    selectedOffer: String
  },
  setup () {
    return { componentUid: useId() };
  },
  data () {
    return {
      isDetailsOpen: false,
      removeLoading: false,
      format: format
    };
  },
  computed: {
    siteInfo () {
      return this.$store.state.siteInfo;
    },
    isSelectedProduct () {
      return this.$props.selectedOffer && this.$props.selectedOffer.split('_')[0] === this.componentUid;
    }
  },
  methods: {
    priceWithDecimals,
    computeTotalPrice,
    toggleDetails () {
      this.isDetailsOpen = !this.isDetailsOpen;
      this.$emit('toggle', this.componentUid);
    },

    isSelectedTariff (index) {
      return this.$props.selectedOffer === index;
    },
    handleClick (index) {
      const offerId = this.siteInfo && this.siteInfo.is_internal_session ? this.$props.item.dynamo_offers[index].uuid : this.$props.item.dynamo_offers[index].horanet_product.horanet_product_code;
      this.$emit('offer-selected', { product: this.$props.item.uuid, offerCode: offerId, id: `${this.componentUid}_${index}` });
    }
  }
};
</script>

<style lang="scss" scoped>
  .details {
    padding: 0;
    user-select: none;
    height: 0px;
    overflow: hidden;
    transition: height 0.2s linear;
  }

  .remove-item {
    top: 10px;
    right: 10px;
  }

  .offer-item{
    background-color: white;
  }

  .offer-item:hover{
    background-color: #ccc;
  }

  .product-title{
    transition: all .2s linear;
  }
  .product-title.selected{
    background-color: var(--selected, #56beee);
    color: white;
  }
</style>
